import 'slick';

( function( $ ) {
	'use strict';

	// alternating features slider
	$( '.card--slider' ).slick( {
		arrows: true,
		dots: false,
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 300,
		mobileFirst: true,
		swipe: true,
		fade: false,
		autoplay: false,
		adaptiveHeight: false,
		rows: 0,
		prevArrow:'<div class=\'mts-prev\'>',
		nextArrow:'<div class=\'mts-next\'>',
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2.2
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 3.2
				}
			},
			{
				breakpoint: 1100,
				settings: {
					slidesToShow: 4
				}
			}
		]
	} );

} )( jQuery );
